import { render, staticRenderFns } from "./DashboardFirstRegistryChart.vue?vue&type=template&id=51e145c0&"
import script from "./DashboardFirstRegistryChart.vue?vue&type=script&lang=js&"
export * from "./DashboardFirstRegistryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports